import React, { useContext, useState } from 'react';
import { Card, Col, Input, Row, Switch } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import firebase from 'firebase';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import checkPermission from '../../../../components/Authorization/Util';
import UserContext from '../../../layout/UserContext';
import AudioUploader from '../../../../firebase/AudioUploader';
import '../../../../assets/textDirection.css';

const { TextArea } = Input;

const Language = ({
  reportData,
  form,
  langCode,
  language,
  defaultLang,
  submit,
}) => {
  const [fileDetailsList, setFileDetailsList] = useState([]);
  const [requiredDetails, setRequiredDetails] = useState(false);

  const onUploadSuccessHandleForm = value => {
    
    setFileDetailsList(value);

    form.setFieldsValue({
      ['audioList-' + langCode]: value,
    });
    
  };

  const getDraggerValue = () => {
    
    const draggerValue = form.getFieldValue('audioList-' + langCode);
    return draggerValue;
  };

  const handleStateChanged = value => {
    if (value) {
      setRequiredDetails(true);
    } else {
      setRequiredDetails(false);
    }
  };

  const { getFieldDecorator } = form;
  const value = useContext(UserContext);
  // const value = this.context;
  const disable = !checkPermission(value, 'appcms', 'write');
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div>
      <Row>
        <Col span={13}>
          <Card bordered={false}>
            {!defaultLang ? (
              <Form.Item label="Published">
                {getFieldDecorator('state-' + langCode, {
                  valuePropName: 'checked',
                  initialValue:
                    reportData &&
                    reportData.state &&
                    reportData.state === 'PUBLISHED',
                })(
                  <Switch
                    checkedChildren="Published"
                    unCheckedChildren="Inherit from Default"
                    disabled={disable}
                    // defaultChecked
                    onChange={handleStateChanged}
                  />,
                )}
              </Form.Item>
            ) : (
              ''
            )}

            <Form.Item label="Title">
              {getFieldDecorator('title-' + langCode, {
                rules:
                  defaultLang || requiredDetails
                    ? [
                        {
                          required: true,
                          message: 'Title is required.',
                        },
                      ]
                    : [],
                initialValue: reportData ? reportData.title : undefined,
              })(
                <Input
                  disabled={disable}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                />,
              )}
            </Form.Item>
            <Form.Item label="Subtitle">
              {getFieldDecorator('subtitle-' + langCode, {
                rules: [],
                initialValue: reportData ? reportData.subtitle : undefined,
              })(
                <TextArea
                  rows={1}
                  disabled={disable}
                  showCount
                  maxLength={60}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                  // style={() => getStyle()}
                />,
              )}
            </Form.Item>

            <Form.Item label="Description">
              {getFieldDecorator('description-' + langCode, {
                rules:
                  defaultLang || requiredDetails
                    ? [
                        {
                          required: true,
                          message: 'Description is required.',
                        },
                      ]
                    : [],
                initialValue: reportData ? reportData.description : undefined,
              })(
                <TextArea
                  rows={15}
                  disabled={disable}
                  showCount
                  maxLength={5000}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                />,
              )}
            </Form.Item>
          </Card>
        </Col>
        <Col span={11}>
          <Card bordered={false} style={{ paddingBottom: '15px' }}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex', paddingBottom: '15px' }}
            >
              {getFieldDecorator('audioList-' + langCode, {
                valuePropName: 'file',
              })(
                <Card title="Audio" style={{ paddingBottom: '15px' }}>
                  <Row justify="center">
                    <AudioUploader
                      storageRef={firebase
                        .storage()
                        .ref(
                          window.location.hostname.split('.')[0] +
                            '/poiAudio-files',
                        )}
                      handleFormValue={onUploadSuccessHandleForm}
                      getDraggerValue={getDraggerValue}
                      fileListData={
                        reportData ? reportData.audioList : undefined
                      }
                      storageFolder={
                        window.location.hostname.split('.')[0] +
                        '/poiAudio-files'
                      }
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      // accept="audio/*"
                      accept=".mp3"
                      maxCount={1}
                      acceptedMessage=" Accepted file types are: mp3"
                      submit={submit}
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Language.propTypes = {
  form: PropTypes.object,
  reportData: PropTypes.object,
  langCode: PropTypes.string,
  language: PropTypes.object,
  defaultLang: PropTypes.string,
  submit: PropTypes.func,
};

Language.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(Language);
